import withPage from '@lib/withPage'; //  Needed due to Next.JS Bug.... Forces HOC Wrap to avoid "The default export is not a React Component in page: "/product"""
import Page from '@src/components/page';
import Product from '@src/components/product/product.jsx';
import {
	addToCart,
	addToCartUnsafe,
	addToCompare,
	addToWishlist,
	getCategoryProps,
	getProduct as getProductData,
	resetCategory,
	setNavigation,
	setSelectedProvider,
} from '@src/redux/actions';
import { setLocation } from '@src/redux/actions/geolocation';
import { setSelectedProviderLocation } from '@src/redux/actions/providerLocation';
import { NextSeo, ProductJsonLd } from 'next-seo';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// TODO: Remove Product out of Redux Linking  Should be passed as a prop

const queryString = require('query-string');

class ProductPage extends Page {
	static propTypes = {
		productId: PropTypes.string,
	};

	constructor(props) {
		super(props);
	}

	static async getInitialProps({ req, store, query: { productid, crossreferenceid, region_id, showpriceonly } }) {
		// TODO: For Now Retrive both items... Will Move KSI Call to BigCommerce API
		showpriceonly = showpriceonly ? showpriceonly : false;

		var categoryid = '';
		if (productid == null) {
			var parsedUrl = queryString.parseUrl(req.url);
			var slug = parsedUrl.url.split('/');
			let cityUrl = null;
			if (slug.length >= 3) {
				categoryid = slug[2];
			}
			if (slug.length >= 4) {
				// FIXME: cityUrl was missing, what is it used for (V.T. 21.12.2021.)
				cityUrl = slug[3];
			}
			var { store_code } = parsedUrl.query;
		}
		const initState = store.getState();

		await store.dispatch(getCategoryProps(categoryid));
		if (store_code) {
			await store.dispatch(setSelectedProviderLocation(store_code, initState.geolocation));
		}

		if (store_code) {
			await store.dispatch(setSelectedProviderLocation(store_code, null));
		}

		// TODO: Do City URL HERE

		await store.dispatch(getProductData(productid, showpriceonly));
		if (crossreferenceid != undefined) {
			categoryid = crossreferenceid;
		}

		return {
			productid: productid,
			crossreferenceid: null,
			showpriceonly: showpriceonly,
		};
	}

	async componentDidUpdate(prevProps, prevState) {
		if (prevProps.geolocation !== this.props.geolocation) {
			await this.props.getProductData(this.props.productid, this.props.showpriceonly);

			if (this.props.crossreferenceid != 'undefined') {
				const categoryid = this.props.crossreferenceid;

				await this.props.getCategoryProps(categoryid);
			} else {
				await store.dispatch(resetCategory());
			}
		}
	}

	componentDidMount() {
		if (this.props.router) {
			this.props.setNavigation({ previousUrl: this.props.router.asPath });
		}
	}

	render() {
		const { item } = this.props;
		const title = '1-800-Battery';

		let hostname = '1800battery.com';
		if (typeof window !== 'undefined') {
			hostname = window.location.hostname;
		}

		return (
			<>
				<NextSeo
					title={`${item?.brand?.brandName} ${item?.name} | ${title}`}
					description={`${item?.shortDescription}.`}
					canonical={`https://${hostname}/product/${this.props.router.query.productid}`}
					openGraph={{
						title: `${item?.brand?.brandName} ${item?.name} | ${title}`,
						description: `${item?.shortDescription}`,
						images: item?.productPictures?.map(img => ({
							url: img.imageUrl,
						})),
						site_name: `${item?.name} | ${title}`,
					}}
				/>
				<ProductJsonLd
					productName={item.name}
					images={item?.productPictures?.map(img => img.imageUrl)}
					description={item.fullDescription}
					brand={item.brand}
					offers={[
						{
							price: item?.selectedProviderService?.providerId?.Price || item.price,
							priceCurrency: 'USD',
						},
					]}
				/>

				<Product
					renderTransferOverlay={!!this.props.showpriceonly}
					item={item}
					symbol={this.props.symbol}
					addToCart={this.props.addToCart}
					addToCartUnsafe={this.props.addToCartUnsafe}
					addToCompare={this.props.addToCompare}
					addToWishlist={this.props.addToWishlist}
					applicationLabel={this.props.applicationLabel}
					applicationProducts={this.props.applicationProducts}
					crossreferenceid={this.props.crossreferenceid}
					category={this.props.category}
					breadcrumbs={this.props.breadcrumbs}
					setSelectedProvider={this.props.setSelectedProvider}
					geolocation={this.props.geolocation}
					productIsLoading={this.props.productIsLoading}
					providerLocation={this.props.providerLocation}
					reviews={this.props.reviews}
					masterProvider={this.props.masterProvider}
					provider={this.props.provider}
				/>
			</>
		);
	}
}

const mapStateToProps = state => ({
	geolocation: state.geolocation,
	item: state.product.item,
	productIsLoading: state.product.isLoading,
	applicationProducts: state.category.products,
	category: state.category,
	applicationLabel: state.category.applicationLabel,
	breadcrumbs: state.category.breadcrumbs,
	providerLocation: state.providerLocation,
	reviews: state.reviews,
	masterProvider: state.masterProvider,
	provider: state.provider,
});

const mapDispatchToProps = {
	addToCartUnsafe,
	addToCart,
	addToWishlist,
	addToCompare,
	getProductData,
	getCategoryProps,
	setSelectedProvider,
	resetCategory,
	setNavigation,
	setSelectedProviderLocation,
	setLocation,
};

export default withPage(connect(mapStateToProps, mapDispatchToProps)(ProductPage));
